import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { Faq } from '../../types/content';
import { useBrand } from '../../contexts/BrandContext';
interface FaqListProps {
  items: Faq[];
}
export function FaqList({
  items
}: FaqListProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const {
    text
  } = useBrand();
  return <ul className="mt-12" data-id="element-254" data-mp="1yho6j6hko9es">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      return <li key={item.question} className="rule" data-id="element-255" data-mp="22ihqxpvt362x" data-mpi={index}>
            <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-6 py-6 text-left" data-id="element-256" data-mp="27h2sbsmsnvsy">
              <span className="font-serif text-xl leading-snug text-ink md:text-2xl" data-id="element-257" data-mp="1eqkqsw1py2hn">
                {item.question}
              </span>
              {isOpen ? <MinusIcon className="mt-1 h-5 w-5 shrink-0 text-brick" strokeWidth={1.5} data-id="element-258" data-mp="25gvf4lbwue7d" /> : <PlusIcon className="mt-1 h-5 w-5 shrink-0 text-ink-muted" strokeWidth={1.5} data-id="element-259" data-mp="21h3dkskxp8bi" />}
            </button>
            <AnimatePresence initial={false} data-id="element-260" data-mp="1wnie0w3p06a7">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-261" data-mp="1rqi7yl6uf3j3">
                  <p className="max-w-2xl pb-7 text-base leading-relaxed text-ink-soft" data-id="element-262" data-mp="18rw7n8j5hgg8">
                    {text(item.answer)}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </li>;
    })}
    </ul>;
}